export const autocompleteItem = class {

    accepted_attributes = ['province_from', 'district_from', 'commune_from', 'city_from'];
    // listened_fields = {};
    fields_from = {};
    values = {};
    element;
    url;
    type;
    current_url;
    is_keypress = false;
    missing_fields = false;

    constructor (element, url) {
        this.element = element;
        this.url = url + '/country-data/';
        this.input = this.element.getElementsByTagName('input')[0];
        this.input.setAttribute('autocomplete', 'off');

        this.prepareRequest();

        if (this.type == 'searchCities' || this.type == 'searchFrmCities') {
            this.input.addEventListener('focus', () => {
                this.input.addEventListener('input', async () =>{
                    if (this.input.value.length == 3) {
                        var label = this.element.getElementsByTagName('label')[0]
                        var html = label.innerHTML;
                        label.innerHTML += '&nbsp;<i class="frm_required fas fa-cog fa-spin"></i>';
                        this.items = await this.makeRequest();
                        label.innerHTML = html;
                        this.autocomplete();
                    } else if (this.input.value.length < 3) {
                        this.closeAllLists();
                    }
                });
            });
        } else {
            this.input.addEventListener('focus', async () => {
                if (this.collectListenedValues()) {
                    var label = this.element.getElementsByTagName('label')[0]
                    var html = label.innerHTML;
                    label.innerHTML += '&nbsp;<i class="frm_required fas fa-cog fa-spin"></i>';
                    this.items = await this.makeRequest();
                    label.innerHTML = html;
                    this.autocomplete();
                }
            });
        }


        this.input.addEventListener('blur', (e) => {
            setTimeout(() => {
                this.closeAllLists();
                this.checkIfValueAccepted();
            }, 300);
        });

    }

    prepareRequest() {
        this.type = this.element.getAttribute('type');
        var attributes = this.element.attributes;
        for (var attribute of attributes) {
            if (!this.accepted_attributes.includes(attribute.name)) continue;
            this.fields_from[attribute.name] = attribute.value;
        }
        if (this.type == 'cities' && !Object.keys(this.fields_from).length) this.type = 'searchCities';
    }

    collectListenedValues() {
        var listened_fields = this.collectListenedFields();
        if (listened_fields === null) {
            return true;
        }
        var value;
        var key;
        for (var listened_field in listened_fields) {
            value = listened_fields[listened_field].value;
            if (value == '') {
                this.throwError(listened_fields[listened_field]);
                return false;
            }
            key = listened_field.replace('_from', '');
            this.values[key] = value;
            listened_fields[listened_field].addEventListener('blur', (e) => {
                if (e.target.value != value) {
                    this.closeAllLists();
                    this.input.value = null;
                }
            });
        }
        this.missing_fields = false;
        this.removeError();
        return true;

    }

    collectListenedFields() {
        if (Object.keys(this.fields_from).length == 0) return null;
        var listened_fields = {};
        for (var item in this.fields_from) {
            var field = this.fields_from[item];
            listened_fields[item] = document.getElementById('field_' + field);
        }
        return listened_fields;
    }

    throwError(listened_field) {
        this.removeError();
        var field_name = listened_field.parentElement.getElementsByTagName('label')[0].innerText;
        field_name = field_name.replace('*', '').trim();
        this.element.insertAdjacentHTML('beforeend', '<div class="frm_error">Uzupełnij pole <i>' + field_name + '</i>.</div>');
        this.missing_fields = true;
    }

    removeError() {
        var errors = this.element.getElementsByClassName('frm_error');
        if (typeof errors === 'undefined') return;
        for (var error of errors) {
            this.element.removeChild(error);
        }
    }

    async makeRequest() {
        var query_string;
        if (this.type == 'searchCities' || this.type == 'searchFrmCities') {
            // if (this.input.value.length != 3) return;
            query_string = 'search_string=' + this.input.value;
        } else {
            query_string = this.serialize(this.values);
        }
        var url = this.url + '?show=' + this.type + (query_string != '' ? '&' + query_string : '');
        var input = this.input;
        var type = this.type;
        if (url == this.current_url) return this.items;
        this.current_url = url;

        return axios({
            method: 'get',
            url: url,
            transformRequest: [(data, headers) => {
                delete headers.common['X-WP-Nonce'];

            }]
        }).then(function (response) {
            if (type != 'searchCities' && type != 'searchFrmCities') input.value = null;
            return response.data;
        })
        .catch(function (error) {
            console.warn(error);
            return;
        })
    }

    serialize(obj) {
        var str = [];
        for (var p in obj)
          if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
          }
        return str.join("&");
    }

    autocomplete() {
        this.prepareList();
        if (this.is_keypress == true) return;
        this.input.addEventListener('input', this.inputListener.bind(null, this));
        this.input.addEventListener('keydown', this.serveKeypresses.bind(null, this));
        this.is_keypress = true;
    }

    inputListener (instance) {
        instance.prepareList();
    }

    async prepareList() {
        if ((this.items == null || typeof this.items == 'undefined' || this.items.length == 0) && (this.type != 'searchCities' && this.type != 'searchFrmCities')) {
            this.input.value = '-';
            return;
        }
        if (this.input.value === '-') {
            this.input.value = '';
        }
        var list_element, list_item, items_element, val = this.input.value.toUpperCase();
        this.closeAllLists();
        this.currentFocus = -1;

        list_element = document.createElement("DIV");
        list_element.setAttribute("class", "autocomplete-wrapper");

        items_element = document.createElement('DIV');
        items_element.setAttribute('class', 'autocomplete-items');
        this.input.after(list_element);
        var i = 0
        for (var item of this.items) {
            if (item.toUpperCase().includes(val)) {
                list_item = document.createElement("DIV");
                list_item.setAttribute('class', 'item');
                if (val.length == 0) {
                    list_item.innerHTML = item;
                } else {
                    var beg = item.toUpperCase().indexOf(val);
                    var end = beg + val.length;
                    list_item.innerHTML = item.substr(0, beg) + 
                        '<span class="bold">' + item.substr(beg, val.length) + '</span>'
                        + item.substr(end);
                }
                items_element.appendChild(list_item);
                if (i > 100) break;
                i++;
            }
        }
        list_element.appendChild(items_element);
        this.list = list_element;
        this.list.addEventListener('click', (e) => {
            this.input.value = e.target.innerText;
            this.closeAllLists(e.target);
        });
    }

    async serveKeypresses(instance, event) {
        var list, scrollable, scroll_val;
        if (instance.list) {
            list = instance.list.getElementsByClassName('item');
            scrollable = instance.list.getElementsByClassName('autocomplete-items')[0];
        }

        if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
            if (event.key == 'ArrowDown') {
                instance.currentFocus++;
            } else {
                instance.currentFocus--;
            }
            instance.addActive(list);

            if (instance.currentFocus >= 0 && scrollable.scrollHeight > instance.list.clientHeight) {
                scroll_val = 0;
                for (var i = 0; i < instance.currentFocus; i++) {
                    scroll_val += list[i].clientHeight;
                }
                instance.list.scrollTop = scroll_val;
            }
        } else if (event.key == 'Tab' && list.length == 1) {
            list[0].click();
        } else if (event.key == 'Enter') {
            event.preventDefault();
            if (instance.currentFocus > -1) {
                if (list) list[instance.currentFocus].click();
            }
            if (list.length == 1) list[0].click();
        }
    }

    addActive(list) {
        if (!list) return false;
        this.removeActive(list);
        if (this.currentFocus >= list.length) this.currentFocus = 0;
        if (this.currentFocus < 0) this.currentFocus = (list.length - 1);
        list[this.currentFocus].classList.add("autocomplete-active");
        this.input.value = list[this.currentFocus].innerText
    }

    removeActive(x) {
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove("autocomplete-active");
        }
    }

    closeAllLists(clicked) {
        if (typeof this.list === 'undefined' || clicked == this.input) return;
        if (this.list.contains(clicked)) {
            this.input.value = clicked.innerText;
        }
        this.list.remove();
    }

    checkIfValueAccepted() {
        if (this.missing_fields == false) {
            this.removeError();
        }
        if (typeof this.items == 'undefined') return;
        if (this.items.length == 0 && this.input.value == '-') return;
        if (this.items.includes(this.input.value)) return;
        var list = this.list.getElementsByTagName('div');
        if (list.length == 1) {
            this.input.value = list[0].innerText;
            return;
        }
        if (this.missing_fields == false) {
            this.element.insertAdjacentHTML('beforeend', '<div class="frm_error">Wybierz wartość z listy.</div>');
        }
        this.input.value = null;
    }


}